export default [
    {
        path: "/fd/mail",
        component: () => import("@/App/FD/Mail/List.vue"),
        name: "mail-list",
        meta: {
            requiresAuth: true,
        },
    },
];
